import { RefObject, useEffect } from 'react'

// Hook to focus on an element when it has an error
export const useFocusOnError = (ref: RefObject<HTMLOrSVGElement>, hasErrors?: boolean, focusOnError?: boolean) => {
  useEffect(() => {
    if (focusOnError && hasErrors) {
      ref?.current?.focus()
    }
  }, [focusOnError, hasErrors, ref?.current])
}
